import SearchOption from 'eop-ui-core/models/SearchOption'
import { Module } from 'vuex'
import { RootState } from '@/store'
import api from '@/api'

export interface PageHelperState {
  helpers: Record<string, PageHelper>
}

type PageHelper = {
  baseUrl: string
  searchOption: SearchOption
  totalCount: number
}

type PageLoadSettings = {
  key: string
  baseUrl: string
  condition?: Record<string, any>
  limit?: number
}

const pageHelper: Module<PageHelperState, RootState> = {
  namespaced: true,
  state: {
    helpers: {},
  },
  mutations: {
    initializeHelper(state, { key, baseUrl, condition, limit }: PageLoadSettings) {
      state.helpers[key] = {
        baseUrl,
        searchOption: new SearchOption({ condition: condition || {}, offset: 0, limit: limit || 20 }),
        totalCount: 0,
      }
    },
    shiftOffset(state, key: string) {
      const { searchOption, totalCount } = state.helpers[key]
      if (searchOption.offset === undefined || !searchOption.limit) {
        return
      }
      if (totalCount > searchOption.offset + searchOption.limit) {
        searchOption.offset += searchOption.limit
      }
    },
  },
  actions: {
    async load({ commit, state }, { key, baseUrl, condition, limit }: PageLoadSettings) {
      await commit('initializeHelper', { key, baseUrl, condition, limit })
      const helper = state.helpers[key]
      if (!helper) {
        return []
      }
      const { data, headers } = (await api.get<any[]>(baseUrl + helper.searchOption.toQueryString())) || {}
      helper.totalCount = Number(headers?.['x-cnsamc-total-count'])
      return data
    },
    loadMore: async ({ commit, state }, key: string) => {
      const helper = state.helpers[key]
      if (helper?.searchOption.offset === undefined) {
        return []
      }
      const beforeOffset = helper.searchOption.offset
      await commit('shiftOffset', key)
      if (beforeOffset < helper.searchOption.offset) {
        const { data, headers } = (await api.get<any[]>(helper.baseUrl + helper.searchOption.toQueryString())) || {}
        helper.totalCount = Number(headers?.['x-cnsamc-total-count'])
        return data
      } else {
        return []
      }
    },
    loadCurrent: async ({ state }, key: string) => {
      const helper = state.helpers[key]
      if (helper?.searchOption.offset === undefined || !helper?.searchOption.limit) {
        return []
      }
      const zeroToCurrent = { ...helper.searchOption }
      zeroToCurrent.offset = 0
      zeroToCurrent.limit = helper.searchOption.offset + helper.searchOption.limit
      const { data, headers } = (await api.get<any[]>(helper.baseUrl + new SearchOption(zeroToCurrent).toQueryString())) || {}
      helper.totalCount = Number(headers?.['x-cnsamc-total-count'])
      return data
    },
  },
}

export default pageHelper
